import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, mergeMap, catchError, tap, switchMap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import {
  entityRPESubActividadesAddFailure,
  entityRPESubActividadesAddRequest,
  entityRPESubActividadesAddSuccess
} from './rpe-sub-actividades.actions';

import { RPESubActividadesService } from './rpe-sub-actividades.service';

@Injectable()
export class RPESubActividadesEffects { 
  // add
  addRequestRPESubActividades = createEffect(() =>
    this.actions$.pipe(
      ofType(entityRPESubActividadesAddRequest),
      switchMap((action) =>
        this.rpeSubActividadesService.addRPESubActividades(action.item).pipe(
          map((item) => entityRPESubActividadesAddSuccess({ item: item })),
          catchError((error) => of(entityRPESubActividadesAddFailure({ error })))
        )
      )
    )
  );

  addSuccessRPESubActividades = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityRPESubActividadesAddSuccess),
        //tap(() => this.router.navigate(['']))
      ),
    { dispatch: false }
  );  

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private rpeSubActividadesService: RPESubActividadesService,
    private router: Router
  ) {
    this.rpeSubActividadesService.url = environment.apiUrl;
  }
}
